<span class="d-flex justify-content-end">&copy;{{settings.getAppSetting('year')}} {{settings.getAppSetting('name')}}; Build ID: {{buildHash}} v{{appVersion}}</span>
